module.exports = __webpack_public_path__ + "assets/on-geofence-fault.59b4e3c0.svg";